import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
        padding: '0'
    },
    gridItem: {
        padding: '0'
    },
    buttonItem: {
        marginTop: theme.spacing(2),

    },
    button: {

        //height: '56px'
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    errorText: {
        color: '#ff0000'
    }
});

interface IEnrolmentConfirmationProps {
}

interface IEnrolmentConfirmationState {
}

export class EnrolmentConfirmation extends Component<IEnrolmentConfirmationProps & WithStyles<typeof styles>, IEnrolmentConfirmationState> {
    constructor(props) {
        super(props);
    }


    public render() {
        const classes = this.props.classes;

        return (
            <Grid className={classes.root} container>
                <Grid item xs={12}>
                    <Grid className={classes.root} container>
                        <Grid item xs={12}>
                            <Typography variant="h2">
                                Enrolment Submitted
                            </Typography>

                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2">
                                Your enrolment has been submitted for review. You can now close this window. 
                            </Typography>
                            <br />
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        );
    }

}

export default withStyles(styles)(EnrolmentConfirmation);

